import { IntegrationConfig } from ".";
import { ObjectType } from "../helpers/models";


export enum Platform {
    square = "square",
    square_sandbox = "square-sandbox",
    /** uber eats KH bridge */
    uberEatsKH = "uber-eats",
    toast = "toast",
    toast_sandbox = "toast-sandbox"
}

/** all available integrations 
 * @note integrations without sandbox env will be available in dev ( so changes can be tested while staging )
 * todo: need to change this in the future, so changes in dev will never affect production. This is a workaround to get results fast
 */
export const platforms = {
    prod: [
        Platform.square,
        // Platform.toast,
        Platform.uberEatsKH
    ],
    dev: [
        Platform.square_sandbox,
        // Platform.toast_sandbox,
        Platform.uberEatsKH
    ]
}



export const IntegrationsConfig: ObjectType<IntegrationConfig> = {
    [Platform.square]: {
        info: "this integration reads delivery orders from your Square Seller Account and display them in your VROMO Account. On the next screen, you will be asked to Grant VROMO Access to your Square Delivery Orders",
        wording: {
            iframe: `square oauth configuration`
        },
        features: {
            iframe: true,
            locations: true,
            selfOnboard: true
        },
    },
    [Platform.square_sandbox]: {
        info: "SANDBOX MODE - this integration reads delivery orders from your Square Seller Account and display them in your VROMO Account. On the next screen, you will be asked to Grant VROMO Access to your Square Delivery Orders",
        wording: {
            iframe: `Square SANDBOX oauth configuration`
        },
        features: {
            iframe: true,
            locations: true,
            sandbox: true,
            selfOnboard: true
        },
    },
    [Platform.toast]: {
        info: "this integration reads delivery orders from your Toast managment Group enabled restaurants and not only display them in your VROMO Account, but also postback certain Vromo job updates to your Toast orders. Please go into your Toast admin panel and add Vromo through Toast Partner connect, in the desired restaurants. A Vromo support person will contact you and finish the configuration",
        features: {
            iframe: false,
            locations: false,
            sandbox: false,
            selfOnboard: false,
            
        },
    },
    [Platform.toast_sandbox]: {
        info: "SANDBOX MODE - this integration reads delivery orders from your Toast managment Group enabled restaurants and not only display them in your VROMO Account, but also postback certain Vromo job updates to your Toast orders. Please go into your Toast admin panel and add Vromo through Toast Partner connect, in the desired restaurants. A Vromo support person will contact you and finish the configuration",
        features: {
            iframe: false,
            locations: false,
            sandbox: true,
            selfOnboard: false
        },
    },
    [Platform.uberEatsKH]: {
        info: "This integration will ingest delivery orders from your Uber Eats merchant Account and display them in your VROMO Account. On the next screen, you will be asked to login into UberEats and then provide the info to sync a new location. It will also postback certain updates from Vromo job to Uber Eats orders",
        features: {
            iframe: false,
            locations: true,
            sandbox: false,
            selfOnboard: true
        },
    }
}
